
export type RegisterType = ("string" | "number" | "boolean");
export type RegisterValue = number | string | boolean | Array<RegisterValue>;
export type RegisterData = {
    type: RegisterType
    value: RegisterValue
}

export class ErrorRegisterTypesMismatch extends Error {
    constructor(value: RegisterValue, current: RegisterValue) {
        super(`Register is being set to ${typeof value} but has a type of ${typeof current}`);
    }
}
export class Register {
    public readonly type: RegisterType;

    private value: RegisterValue;

    constructor(data: RegisterData) {
        this.type = data.type || (typeof data.value === "number" ? "number" :
            (typeof data.value === "string" ? "string" : "boolean"));
        this.value = data.value;
    }

    public get(): RegisterValue {
        return this.value;
    }
    public set(value: RegisterValue) {
        if (typeof this.value !== typeof value) {
            throw new ErrorRegisterTypesMismatch(value, this.value);
        }
        this.value = value;
    }
    public serialise() : RegisterData {
        return {
            value: this.value,
            type: this.type
        };
    }
}